export interface WithdrawAmountItem {
  id: string
  text: string
  amount: string
}

export const withdrawAmountList: WithdrawAmountItem[] = [
  {
    id: '1',
    text: '150',
    amount: '150'
  },
  {
    id: '2',
    text: '200',
    amount: '200'
  },
  {
    id: '3',
    text: '500',
    amount: '500'
  },
  {
    id: '4',
    text: '1,000',
    amount: '1,000'
  },
  {
    id: '5',
    text: '2,000',
    amount: '2,000'
  },
  {
    id: '6',
    text: '5,000',
    amount: '5,000'
  }
]
// export const bankCodeMapping: Record<string, string> = {
//   vcb: 'Vietcombank',
//   acb: 'ACB',
//   donga: 'DongA',
//   vietinbank: 'VietinBank',
//   bidv: 'BIDV',
//   sacombank: 'Sacombank',
//   techcombank: 'Techcombank',
//   eximbank: 'Eximbank',
//   vpbank: 'VPbank',
//   mbbank: 'MBbank',
//   shb: 'SHB',
//   vietcapital: 'VietCapital',
//   agribank: 'Agribank',
//   tpbank: 'TPbank',
//   hdbank: 'HDBank',
//   pvcombank: 'PVcombank',
//   namabank: 'NamABank',
//   scb: 'Sài Gòn Bank',
//   ocb: 'Phương Đông Bank',
//   baovietbank: 'BAOVIETBANK',
//   lpb: 'Liên Việt Post bank',
//   scbl: 'Standard Chartered Bank',
//   abbank: 'ABbank',
//   ncb: 'Quốc Dân Bank',
//   vab: 'VIETABANK',
//   vid: 'Public Bank',
//   vncb: 'CBbank',
//   sgb: 'Saigonbank',
//   oceb: 'Ocean Bank',
//   bvbank: 'BAOVIETBANK',
//   ivb: 'NDOVINA',
//   vibbank: 'VIB Bank',
//   msb: 'Maritime Bank'
// }
